import axios from 'axios';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && body.success === true) {
    return body.data ?? null;
  }
  return body ?? null;
}

export async function fetchLeadsMeta(apiUrl) {
  const res = await axios.get(`${apiUrl}/api/leads/meta`);
  return unwrap(res);
}

function importForm(file, mapping, extra = {}) {
  const form = new FormData();
  form.append('file', file);
  if (mapping && Object.keys(mapping).length) {
    form.append('mapping', JSON.stringify(mapping));
  }
  Object.entries(extra).forEach(([k, v]) => form.append(k, String(v)));
  return form;
}

const UPLOAD_CONFIG = {
  headers: { 'Content-Type': 'multipart/form-data' },
  timeout: 120000,
};

/** Validate a CSV/Excel lead file and report what an import would do. Writes nothing. */
export async function previewLeadImport(apiUrl, file, mapping) {
  const res = await axios.post(`${apiUrl}/api/leads/import/preview`, importForm(file, mapping), UPLOAD_CONFIG);
  return unwrap(res);
}

/** Import a CSV/Excel lead file. `mapping` is an optional {field: column header} override. */
export async function importLeadsFile(apiUrl, file, mapping) {
  const res = await axios.post(`${apiUrl}/api/leads/import`, importForm(file, mapping), UPLOAD_CONFIG);
  return unwrap(res);
}

/** Read a CSV/Excel into a cleaned campaign recipient list; optionally saves new numbers as leads. */
export async function importCampaignRecipients(apiUrl, file, { mapping, saveNewToLeads = false } = {}) {
  const res = await axios.post(
    `${apiUrl}/api/leads/import/campaign-recipients`,
    importForm(file, mapping, { save_new_to_leads: saveNewToLeads }),
    UPLOAD_CONFIG,
  );
  return unwrap(res);
}

export async function previewAudience(apiUrl, payload) {
  const res = await axios.post(`${apiUrl}/api/leads/audience-preview`, payload);
  return unwrap(res);
}

export async function listLeads(apiUrl, params = {}) {
  const res = await axios.get(`${apiUrl}/api/leads`, { params });
  return unwrap(res);
}
